import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from './auth.service';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {

  constructor(public auth: AuthService, private router: Router) {}

  canActivate() {
    if (this.auth.loged()) {
      return true
    } 
    else {
      this.router.navigate(['/set-location']);
      return false
    }
  }
  
}
@Injectable({providedIn: 'root'})
export class SafeGuard implements CanActivate {

  constructor(public auth: AuthService, private router: Router) {}

  canActivate() {
    if (!this.auth.loged()) {
      return true
    } 
    else {
      if(this.auth.checkCapability('SP')&&!this.auth.checkCapability('FSA')&&!this.auth.checkCapability('SC') && !this.auth.checkCapability('SPVR')&&!this.auth.checkCapability('VM') &&!this.auth.checkCapability('CUSTRQH') &&!this.auth.checkCapability('CUSTSUP')){
        this.router.navigate(['/vendor-request']);
      }else  if(this.auth.checkCapability('CUST') && !this.auth.checkCapability('SP')&&!this.auth.checkCapability('FSA')&&!this.auth.checkCapability('SC') && !this.auth.checkCapability('SPVR')&&!this.auth.checkCapability('VM') &&!this.auth.checkCapability('CUSTRQH') &&!this.auth.checkCapability('CUSTSUP')){
        if(!this.auth.loged()){
          this.router.navigate(['/set-location']);
        }else{
          this.router.navigate(['/bookservice1']);
        }
      }else if((this.auth.checkCapability('FSA') || this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))&&!this.auth.checkCapability('SC')){
        this.router.navigate(['/vendor-manage-order']);
      }else {
        if(this.auth.checkCapability('SC'))
        this.router.navigate(['/requests']);
      }
      
      return false
    }
  }
  
}